// Site constants

export const NAV_BREAKPOINT = 920;
export const MOBILE_BREAKPOINT = 600;
export const IS_IE9 = window.isIE9 || false;

// Only hide :focus styles when the user is using a mouse

export default function hideFocusStylesForMouse() {
  document.body.addEventListener('mousedown', () => {
    document.body.classList.add('using-mouse');
  });
  document.body.addEventListener('keydown', () => {
    document.body.classList.remove('using-mouse');
  });
}

// Body scroll managers

const $body = document.querySelector('body');
const $hiddenNavGradient = document.querySelector('.hidden-nav-gradient');

export function disableBodyScroll() {
  const scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop;

  $body.style.overflow = 'hidden';
  $body.style.position = 'fixed';
  $body.style.top = (scrollTop * -1) + 'px';
  if ($hiddenNavGradient) $hiddenNavGradient.style.display = 'none';
}

export function enableBodyScroll() {
  $body.style.overflow = 'auto';
  $body.style.position = 'static';
  $body.style.top = 0;
  if ($hiddenNavGradient) $hiddenNavGradient.style.display = 'block';
}

// Event throttlers

export class ScrollThrottler {
  constructor() {
    this.scrollTimeout = null;
    this.scrollFunctions = [];
    this.throttle = this.throttle.bind(this);
    window.addEventListener('scroll', this.throttle, false);
  }

  add(fn) {
    this.scrollFunctions.push(fn);
  }

  remove(fn) {
    this.scrollFunctions = this.scrollFunctions.filter(setFn => setFn !== fn);
  }

  throttle() {
    if (!this.scrollTimeout) {
      this.scrollTimeout = setTimeout(() => {
        this.scrollTimeout = null;
        this.scrollFunctions.forEach((fn) => {
          fn();
        });
      }, 16);
    }
  }

  destroy() {
    this.scrollTimeout = null;
    window.removeEventListener('scroll', this.throttle);
  }
}

export class ResizeThrottler {
  constructor() {
    this.resizeTimeout = null;
    this.resizeFunctions = [];
    this.throttle = this.throttle.bind(this);
    window.addEventListener('resize', this.throttle, false);
  }

  add(fn) {
    this.resizeFunctions.push(fn);
  }

  remove(fn) {
    this.resizeFunctions = this.resizeFunctions.filter(setFn => setFn !== fn);
  }

  throttle() {
    if (!this.resizeTimeout) {
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = null;
        this.resizeFunctions.forEach((fn) => {
          fn();
        });
      }, 66);
    }
  }

  destroy() {
    this.resizeTimeout = null;
    window.removeEventListener('resize', this.throttle);
  }
}
